import { forwardRef } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useIconTheme } from 'framework/Icon/hooks/useIconTheme';

import { EMPTY_FUNCTION } from '../../constants';

import { IconElement } from './elements';
import { IconProps } from './types';

import cn from './Icon.module.scss';

export const Icon = forwardRef<HTMLDivElement, IconProps>(
  (
    {
      icon,
      height,
      width,
      size = '13px',
      disabled = false,
      error = false,
      button = false,
      onMouseDown = EMPTY_FUNCTION,
      onClick = EMPTY_FUNCTION,
      theme,
      children,
    },
    ref
  ) => {
    const icon_theme = useIconTheme(theme);
    if (!icon) return null;

    return (
      <IconElement
        ref={ref}
        className={cn.icon}
        height={height}
        width={width}
        size={size}
        data-button={button}
        data-error={error}
        data-disabled={disabled}
        theme={icon_theme}
        onMouseDown={(e) => {
          if (!disabled) onMouseDown(e, 'icon');
        }}
        onClick={(e) => {
          if (!disabled) onClick(e);
        }}
      >
        <FontAwesomeIcon icon={icon} />
        {children}
      </IconElement>
    );
  }
);
